import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import Component from 'components/SupplierIntegration/Filter'

const mapStateToProps = (state, props) => ({ ...createAuthStateToProps(state, props) })

export default connect(mapStateToProps, null)(Component)
